import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left--custom",
  "use": "icon-arrow--left--custom-usage",
  "viewBox": "0 0 11 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 16\" id=\"icon-arrow--left--custom\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.172 15.5 11 12.672 6.173 7.844 11 3.017 8.172.188.516 7.844 8.172 15.5Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol